import React, { useEffect, useState } from 'react';
import { Icon } from '@shakkerai/components';
import { translate } from '@shakkerai/util-i18n';
import { setTempState, useTempState, useUnitData } from '@starflow/app/store';
import { ModelWindowWrapper, Tab } from '../base/Wrapper';
import { Favorites } from './Favorites';
import { History } from './History';
import { AllLoras } from './All';
import { updatePartialState } from '../../store/state';
import { mc } from '@shakkerai/report';

export { LoraDetailWindow } from './Detail';

const tabOptions = [
  { value: 'all', label: translate('history_tab1') },
  {
    value: 'favorites',
    label: (
      <>
        <Icon className="shk-danchuang-shoucang_s -translate-y-px" color="inherit" fontSize={12} />
        <span className="ml-1 text-sm">{translate('models_favorites')}</span>
      </>
    ),
  },
  { value: 'history', label: translate('style_history_new') },
];

const tabContents = {
  favorites: Favorites,
  history: History,
  all: AllLoras,
};

export const LorasWindow = React.memo(() => {
  const currentTab = useTempState('lorasTab') || 'all';
  const [isReady, setIsReady] = useState(false);
  const { baseType } = useUnitData();
  const newlyFavoritedModel = useTempState('newlyFavoritedModel');

  const Content = tabContents[currentTab];

  const handleSwitchTab = (lorasTab) => {
    setTempState({ lorasTab });
  };

  useEffect(() => {
    if (baseType) {
      const baseTypes = [baseType + ''];
      // 将全部和历史的 tab 的baseTypes都设置为当前的 baseType
      updatePartialState('lora.all.filters', (filters) => (filters.keyword ? {} : { baseTypes }));
      updatePartialState('lora.history.filters', (filters) => (filters.keyword ? {} : { baseTypes }));
    }

    setIsReady(true);
  }, [baseType]);

  useEffect(() => {
    if (newlyFavoritedModel && newlyFavoritedModel.modelType?.toLowerCase() === 'lora') {
      handleSwitchTab('favorites');
    }
  }, [newlyFavoritedModel]);

  useEffect(() => {
    mc('tool.model.show', { type: 'lora' });

    return () => {
      setTempState({ loraToReplace: null });
    };
  }, []);

  if (!isReady) return null;

  return (
    <ModelWindowWrapper
      type="loras"
      currentTab={currentTab}
      label={translate('model_window_title_lora')}
      tabs={<Tab value={currentTab} onChange={handleSwitchTab} options={tabOptions} />}
    >
      <div className="flex flex-col flex-1 overflow-hidden">{Content ? <Content /> : null}</div>
    </ModelWindowWrapper>
  );
});
